/*
* Info表示用の共通処理
*/
const $ = require('jquery')

module.exports = (function () {
  /*
    * チップス表示用の処理
    * [サンプルHTML]
    *<span class="info-container package-error js-info-container">
    *  <svg class="icon-alert">
    *    <use xlink:href="/static/svg/svg.svg#icon-alert">
    *  </svg>
    *  エラー詳細
    *  <span class="info-container-tips js-info-container-tips">
    *    <span class="error-messages">システムエラーが発生しました。しばらく時間を開けたのち、再度お試しください。解決しない場合はお問い合わせください。</span>
    *  </span>
    *</span>
    */
  function run () {
    $('.js-info-container').viewManager(function () {
      const that = this
      this.$el.hover(function () {
        const $parent = $(this)

        // infoが表示される時に別のinfoが開いていた場合は即座に隠す。
        // 被り防止
        that.$el.find('.js-info-container-tips').hide()

        $parent.find('.js-info-container-tips').show()
        $parent.addClass('js-is-hover active')
        $parent.find('.js-info-container-tips').addClass('js-is-hover')
      }, function () {
        const $parent = $(this)
        $parent.removeClass('js-is-hover')
        $parent.find('.js-info-container-tips').removeClass('js-is-hover')
        window.setTimeout(function () {
          if ($parent.find('.js-is-hover').length) {
            return
          }
          $parent.find('.js-info-container-tips').hide()
          $parent.removeClass('active')
        }, 1000)
      })
    })
  }

  return {
    run: run
  }
})()
